var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoiceAiWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1773130129833,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 9322,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.6 512a224 224 0 0 0 447.68 11.136L737.6 512v-56h56V512a280.064 280.064 0 0 1-251.968 278.592v113.344h112V960H373.632v-56.064h112v-113.344A280.064 280.064 0 0 1 233.6 512v-56h56V512z",
    fill: "#ffffff",
    "p-id": 9323,
    "data-spm-anchor-id": "a313x.search_index.0.i0.6b1b3a81oP8Mry",
    className: "selected"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M513.6 120A112 112 0 0 0 401.92 223.616l-0.32 8.32V512a112 112 0 0 0 223.68 8.32L625.6 512V320h56v192A168 168 0 0 1 345.6 512V232A168 168 0 0 1 513.664 64v56z",
    fill: "#ffffff",
    "p-id": 9324,
    "data-spm-anchor-id": "a313x.search_index.0.i1.6b1b3a81oP8Mry",
    className: "selected"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M668.032 64c9.664-0.576 12.48 10.368 16.32 25.216 4.096 15.936 9.408 36.416 25.536 51.968 15.808 15.232 36.032 20.16 52.352 24 15.808 3.84 27.904 6.72 28.544 17.408 0.64 11.136-12.544 15.616-29.056 21.12-15.552 5.248-34.048 11.392-46.848 25.152-12.608 13.44-17.856 30.08-22.272 43.84-4.864 15.296-8.64 27.136-19.968 27.648-10.368 0.512-12.992-9.216-16.704-22.784v-0.064c-4.096-14.848-9.344-34.176-27.2-49.6-16.704-14.4-35.008-19.776-49.28-23.936l-0.32-0.128c-14.912-4.416-25.472-7.552-25.536-18.24 0-10.112 10.368-12.608 24.32-15.936 15.232-3.584 34.88-8.192 50.496-24.768 15.552-16.576 20.224-37.376 23.936-53.696 3.392-15.168 6.016-26.496 15.68-27.136z",
    fill: "#ffffff",
    "p-id": 9325,
    "data-spm-anchor-id": "a313x.search_index.0.i2.6b1b3a81oP8Mry",
    className: "selected"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceAiWhite);
export default __webpack_public_path__ + "static/media/voice_ai_white.e5a675e8.svg";
export { ForwardRef as ReactComponent };